module.exports = __webpack_public_path__ + "static/media/send.8b275315.gif";